import Data from "../types/Data";

export default function lastReceiptHasNOrMoreItems(data: Data, n: number) {
  let receipt = data.Receipt[data.receiptIds[data.receiptIds.length - 1]];
  if (!receipt) {
    return true;
  }
  return receipt.itemIds.length >= n;
}
